import { useQuery } from "@tanstack/react-query";
import { getAccountingOverview } from "../services/accountingService";


// ✅ Add "all_time" here
export type PeriodType = "month" | "quarter" | "year" | "all_time";

export const useAccountingDashboard = (periodType: PeriodType) => {
  return useQuery({
    queryKey: ["accounting_dashboard", periodType],
    queryFn: () => getAccountingOverview(periodType),
    staleTime: 1000 * 60 * 5,
  });
};